import type { Invitation, CreateInvitationInput, InvitationValidation } from '@peles/shared';
import { apiClient } from './client';

export async function createInvitation(data: CreateInvitationInput): Promise<Invitation> {
  const { data: invitation } = await apiClient.post<Invitation>('/invitations', data);
  return invitation;
}

export async function listInvitations(eventId?: string): Promise<Invitation[]> {
  const params = eventId ? { eventId } : undefined;
  const { data } = await apiClient.get<Invitation[]>('/invitations', { params });
  return data;
}

export async function validateInvitation(token: string): Promise<InvitationValidation> {
  const { data } = await apiClient.get<InvitationValidation>(`/invitations/validate/${token}`);
  return data;
}

export async function acceptInvitation(
  token: string,
  input?: { name?: string },
): Promise<Invitation> {
  const { data } = await apiClient.post<Invitation>(`/invitations/accept/${token}`, input || {});
  return data;
}
